import { ModelWrapper } from "app/pages/individual/component/ModelWrapper";
import { IndividualChat } from "app/pages/jobs/Individual-jobs/IndividualChat";
import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { Checkbox } from "sr/helpers";
import { DateFormat } from "sr/helpers/functions/DateFormat";
import { getUserDetails } from "sr/helpers/functions/getUserDetails";
import ContentWithSpinner from "sr/layout/common/ContentWithSpiner";
import { getJob } from "sr/utils/api/individual/job/getJob";
import { getUnreadJob } from "sr/utils/api/individual/job/getUnreadJob";
import { Noselected } from "../../Noselected";

export const IndividualMessage = () => {
  const [cleanerId, setCleanerId] = useState<string>();
  const [tab, setTab] = useState("Inbox");
  const [IndividualJob, setIndividualJob] = useState<[]>();
  const [unreadJobs, setUnreadJobs] = useState([]);
  const [currentJobId, setCurrentId] = useState<string>();
  const [currentData, setCurrentData] = useState<[]>();
  const [loader, setLoader] = useState(true);
  const [modelShow, setmodelShow] = useState(false);
  const [localMessageTimes, setLocalMessageTimes] = useState<Record<string, string>>({});

  useEffect(() => {
    const { user_id } = getUserDetails();
    setCleanerId(user_id);
  }, []);
  const HandleModelByProps = (data) => {
    setmodelShow(data);
  };

  const fetchIndividualJobs = async () => {
    try {
      setLoader(true);
      const queryParams = new URLSearchParams();
      queryParams.append("cleaner_id", cleanerId);
      const res = await getJob(queryParams);
      if (res?.success === true) {
        setIndividualJob(res?.data);
        if (res?.data?.length > 0) {
          setCurrentData(res?.data[0]);
          setCurrentId(res?.data[0]?.id);
        }
        setLoader(false);
      } else {
        setLoader(false);
      }
    } catch (e) {
    } finally {
      setLoader(false);
    }
  };
  const fetchUnreadJobs = async () => {
    try {
      const queryParams = new URLSearchParams();
      queryParams.append("cleaner_id", cleanerId);
      const res = await getUnreadJob(queryParams);
      if (res?.success === true) {
        setUnreadJobs(res?.data);
        setLoader(false);
      }
    } catch (e) {
    } finally {
      setLoader(false);
    }
  };
  useEffect(() => {
    if (cleanerId) {
      fetchIndividualJobs();
      fetchUnreadJobs();
    }
  }, [cleanerId]);
  return (
    <ContentWithSpinner loader={loader} height="h-screen">
      <div className="lg:container mx-auto lg:max-w-6xl lg:mt-5 mt-5 px-4 lg:px-0">
        <div
          className={`flex border-y h-full card-1 bg-white border border-gray-border rounded-xl`}
        >
          <div className="py-3 w-[33%] border-r-2 border-neutral-300 h-[60vh] overflow-x-auto">
            <div className="flex items-center mb-3 px-4">
              <div
                onClick={() => setTab("Inbox")}
                className={`rounded-l-lg ${
                  tab === "Inbox"
                    ? "bg-[#ff39b3] text-white"
                    : "bg-white text-[#0078ae] border border-neutral-200"
                } font-bold px-3 py-1  cursor-pointer`}
              >
                <FormattedMessage
                  id="RECRUITER.MESSAGES.TOGGLE.BUTTON.INBOX"
                  defaultMessage="Inbox"
                />
              </div>
              <div
                onClick={() => setTab("Unread")}
                className={`rounded-r-lg flex-1 text-center ${
                  tab === "Unread"
                    ? "bg-[#ff39b3] text-white"
                    : "bg-white text-[#0078ae] border border-neutral-200"
                } font-bold px-3 py-1  cursor-pointer`}
              >
                <FormattedMessage
                  id="RECRUITER.MESSAGES.TOGGLE.BUTTON.UNREAD"
                  defaultMessage="Unread"
                />
                ({unreadJobs?.length})
              </div>
            </div>
            <div className="flex items-center space-x-3 relative px-4">
              <div
                onClick={() => setmodelShow(!modelShow)}
                className="flex-1 flex items-center py-2 px-2 justify-between border rounded-lg border-black hover:shadow-inputshadow hover:border-[#0078ae]"
              >
                <span>
                  <b>
                    <FormattedMessage
                      id="RECRUITER.MESSAGES.FILTER.TITLE"
                      defaultMessage="Filter by job"
                    />
                    :
                  </b>{" "}
                  <FormattedMessage
                    id="RECRUITER.MESSAGES.FILTER.COMMON.TYPE"
                    defaultMessage="All Jobs"
                  />
                </span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-4 h-4"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                  />
                </svg>
              </div>
              <svg
                onClick={fetchIndividualJobs}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-6 h-6 cursor-pointer text-[#0078ae]"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"
                />
              </svg>

              {modelShow && (
                <ModelWrapper
                  HandleModelByProps={HandleModelByProps}
                  topPosition="top-5"
                  border="border border-black"
                >
                  <div className=" w-full px-4 py-4">
                    <Checkbox
                      id="Web"
                      label="Web Developer - Lucknow, Uttar Pradesh"
                      name="Web"
                      value="Web Developer - Lucknow, Uttar Pradesh"
                    />
                  </div>
                </ModelWrapper>
              )}
            </div>
            <hr className="border-2 border-neutral-200 mt-4"></hr>
            {(() => {
              const getLastMessageTime = (data) => {
                  const key = `${cleanerId}_${data?.id}`;
                  if (localMessageTimes[key]) return localMessageTimes[key];
                  return data?.lastMessageTime || data?.createdAt;
              };
              
              const listToRender = tab === "Inbox" ? IndividualJob : unreadJobs;
              const sortedList = [...(listToRender || [])].sort((a, b) => {
                  const timeA = new Date(getLastMessageTime(a)).getTime();
                  const timeB = new Date(getLastMessageTime(b)).getTime();
                  return timeB - timeA;
              });

              return sortedList?.map((data) => (
              <div
                key={data?.id}
                onClick={() => {
                  setCurrentId(data?.id);
                  setCurrentData(data as any);
                }}
                className={`${
                  currentJobId === data?.id
                    ? "bg-[#ecf5ff]"
                    : "bg-white hover:bg-[#faf9f8]"
                }  p-4 border-b border-neutral-200  cursor-pointer`}
              >
                <div className="flex items-center justify-between space-x-2">
                  <span className="text-gray-600 font-sm">
                    Applied to {data?.title}
                  </span>
                  <span className="text-gray-600 font-sm">
                    {DateFormat(getLastMessageTime(data))}
                  </span>
                </div>
                <p className="">
                  {data?.individual_id?.first_name}{" "}
                  {data?.individual_id?.last_name}
                </p>
              </div>
            ))
            })()}
          </div>
          <div className="flex-1 w-[65%] h-[80vh] ">
            {currentJobId ? (
              <IndividualChat
                jobId={currentJobId}
                type={"component"}
                updateLastMessageTime={(cleanerId, jobId, time) => setLocalMessageTimes(prev => ({...prev, [`${cleanerId}_${jobId}`]: time}))}
              ></IndividualChat>
            ) : (
              <Noselected />
            )}
          </div>
        </div>
      </div>
    </ContentWithSpinner>
  );
};
